<template>
  <div class="metrics-pagination">
    <span class="metrics-pagination__label paragraph-s">
      <slot name="label" />
    </span>

    <nav class="metrics-pagination__nav">
      <!-- Previous -->
      <eg-button
        type="ordinary"
        size="small"
        icon="arrow-left"
        :disabled="value <= 1"
        @click="changePage(value - 1)"
        >{{ $t("metrics.previous") }}</eg-button
      >

      <!-- Pages -->
      <template v-for="(item, i) in pages">
        <span
          v-if="item === 'ellipsis'"
          :key="'e' + i"
          class="metrics-pagination__ellipsis"
        >
          &hellip;
        </span>
        <eg-button
          v-else
          :key="item"
          size="small"
          :type="item === value ? 'primary' : 'ordinary'"
          class="metrics-pagination__page"
          @click="changePage(item)"
        >
          {{ item }}
        </eg-button>
      </template>

      <!-- Next -->
      <eg-button
        type="ordinary"
        size="small"
        right-icon="arrow-right"
        :disabled="value >= totalPages"
        @click="changePage(value + 1)"
      >
        {{ $t("common.next") }}
      </eg-button>
    </nav>
  </div>
</template>

<script>
export default {
  name: "MetricsPagination",

  props: {
    value: {
      type: Number,
      required: true,
    },
    totalRows: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
  },

  emits: ["change"],

  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.totalRows / this.perPage));
    },

    pages() {
      const total = this.totalPages;
      const current = this.value;

      if (total <= 7) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }

      if (current <= 3) {
        return [1, 2, 3, "ellipsis", total - 1, total];
      }

      if (current >= total - 2) {
        return [1, 2, "ellipsis", total - 2, total - 1, total];
      }

      return [
        1,
        "ellipsis",
        current - 1,
        current,
        current + 1,
        "ellipsis",
        total,
      ];
    },
  },

  methods: {
    changePage(page) {
      if (page < 1 || page > this.totalPages || page === this.value) return;
      this.$emit("change", page);
    },
  },
};
</script>

<style lang="scss" scoped>
.metrics-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-top: 1px solid var(--color-stroke-neutral-default, #e5ebf0);

  &__label {
    color: var(--color-text-neutral-secondary, #566370);
    font-size: 12px;
    white-space: nowrap;
  }

  &__nav {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &__page {
    min-width: 32px;
  }

  &__ellipsis {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    height: 32px;
    font-size: var(--typography-font-size-fs-300, 14px);
    color: var(--color-text-neutral-fade, #8a97a4);
    user-select: none;
  }
  .eg-new-button {
    font-size: var(--typography-font-size-fs-300);
  }
}
</style>
